import {
  Box,
  Container,
  Flex,
  GridItem,
  Heading,
  Image,
  Link,
  SimpleGrid,
  Text,
} from "@chakra-ui/react";
import logo from "../../../assets/logo.svg";
import { SocialButtons } from "../index";

export default function FooterCredits() {
  return (
    <Box bg="talesYellow.500" p="20px">
      <Container maxW="7xl" m="auto">
        <SimpleGrid
          columns={{ base: 1, lg: 4 }}
          minChildWidth="200px"
          rowGap="20px"
          columnGap="20px"
        >
          <GridItem colSpan={{ base: 1, lg: 1 }}>
            <Image src={logo} />
          </GridItem>
          <GridItem colSpan={{ base: 1, lg: 3 }}>
            <Heading size="base">Credits</Heading>
            <Text as="p" variant="footer">
              Tales Montagnana è una manifestazione organizzata da APS Di Regola
              Arte (CF 91024830282 | P.Iva 05770770286) in collaborazione con
              Pro Loco Montagnana ed è patrocinata dal Comune di Montagnana e
              dalla Regione del Veneto.
            </Text>
            <Heading size="base" mt="20px">
              Contatti
            </Heading>
            <Flex
              direction={{ base: "column", md: "row" }}
              align={{ base: "start", md: "center" }}
            >
              <Text
                as="p"
                variant="footer"
                mr={{ base: "0", md: "20px" }}
                mb={{ base: "10px", md: "0" }}
              >
                talesmontagnana@gmail.com
              </Text>
              <SocialButtons />
            </Flex>

            <Text as="p" variant="footer">
              La manifestazione si terrà nel centro storico di Montagnana (PD) -
              35044 nei pressi della Rocca degli alberi.
            </Text>
            <Link href="https://maps.app.goo.gl/j1p7XkbR6EDtQkQG7">
              https://maps.app.goo.gl/j1p7XkbR6EDtQkQG7
            </Link>
            <Box maxW="100%" overflow="hidden">
              <iframe
                title="Tales Maps"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2809.6511009142896!2d11.462512100000001!3d45.23462500000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477f10a32ca52f09%3A0x34e3f6e7312011b2!2sRocca%20degli%20Alberi!5e0!3m2!1sit!2sit!4v1705322096711!5m2!1sit!2sit"
                width="100%"
                height="300"
                style={{ maxWidth: "350px" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </Box>
          </GridItem>
        </SimpleGrid>
      </Container>
    </Box>
  );
}
